import React from 'react';
import UntilDateStrategy from './UntilDateStrategy';
import { IStrategyProps } from './MissionStatus';

const NowPlanableStrategy: React.FC<IStrategyProps> = ({ disabled }) => (
  <UntilDateStrategy disabled={disabled} />
);

export default NowPlanableStrategy;
